import { useEffect, useState } from "react";
import { Heart, X, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { PageHead, Card } from "@/pages/app/AppShell";
import { api, errMsg } from "@/lib/api";

export default function Wishlist() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const load = () => api.get("/wishlist").then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  useEffect(() => { load(); }, []);
  const add = async () => {
    try { await api.post("/wishlist", { name }); setName(""); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="wishlist-page">
      <PageHead kicker="Brand wishlist" title="My dream partners" />
      <Card className="p-6">
        <p className="text-sm text-slate-300">Add the brands you'd love to work with. The moment one of them opens an opportunity or brief, we'll alert you in-app and by email.</p>
        <div className="mt-5 flex gap-3">
          <input className="field" placeholder="Brand name" value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && name.trim() && add()} data-testid="wishlist-name-input" />
          <button className="btn-gold shrink-0" disabled={!name.trim()} onClick={add} data-testid="wishlist-add-button"><Plus className="h-4 w-4" />Add</button>
        </div>
      </Card>
      <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-testid="wishlist-list">
        {!items.length && <p className="sm:col-span-3 rounded-2xl border border-dashed border-[#2A1240]/15 p-10 text-center text-slate-300" data-testid="wishlist-empty">Your wishlist is empty.</p>}
        {items.map((w) => (
          <div key={w.name} className="group flex items-center justify-between rounded-2xl border border-[#2A1240]/10 bg-[#FFFFFF] px-5 py-4 hover:border-[#E0218A]/40 transition-colors" data-testid={`wishlist-item-${w.name.toLowerCase().replace(/\W+/g, "-")}`}>
            <span className="flex items-center gap-3">
              <Heart className="h-4 w-4 fill-[#E0218A] text-[#E0218A]" />
              <span className="font-display text-xl text-[#2A1240]">{w.name}</span>
            </span>
            <span className="flex items-center gap-3">
              {w.company_id ? <Link to={`/companies/${w.company_id}`} className="text-[11px] uppercase tracking-wider text-emerald-300">On Balqis</Link> : <span className="text-[11px] uppercase tracking-wider text-slate-400">Watching</span>}
              <button className="text-slate-400 hover:text-red-300" onClick={() => api.delete(`/wishlist/${encodeURIComponent(w.name)}`).then(load)} aria-label={`Remove ${w.name}`} data-testid={`wishlist-remove-${w.name.toLowerCase().replace(/\W+/g, "-")}`}><X className="h-4 w-4" /></button>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
